import React from "react";
import './UpdateIssue.css';

export default function () {
    return <span className="updateIssueLabel">
        <i className="nepfont_clock"></i>
        Update Issue
    </span>
}
